import { render, staticRenderFns } from "./EditPointOfInterest.vue?vue&type=template&id=0579ac8e&scoped=true"
import script from "./EditPointOfInterest.vue?vue&type=script&lang=js"
export * from "./EditPointOfInterest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0579ac8e",
  null
  
)

export default component.exports